import { AreaNotification } from "@relode/core";
import * as React from "react";

import {
    CandidateProvider,
    useCandidateContext,
} from "../_infra/candidateProvider";
import { CandidateDetails } from "./candidate/candidateDetails";

export const CandidateContainer = () => (
    <CandidateProvider>
        <CandidateContainerWrapper />
    </CandidateProvider>
);

const CandidateContainerWrapper = () => {
    const {
        state: {
            data: { candidate },
        },
    } = useCandidateContext();

    return (
        <>
            <AreaNotification areaName="loadCandidate" />
            {candidate ? <CandidateDetails /> : null}
        </>
    );
};
